import React from "react"
import { connect } from "react-redux"
import { compose } from "redux"
import PropTypes from "prop-types"
import styled from "styled-components"
import { darken } from "polished"
import { media } from "../../utils/style-utils"
import { translate } from "react-i18next"

const glowAnimation = `@keyframes glowing {
    0% { box-shadow: 0 0 -10px ${props => props.primaryColor}; }
    40% { box-shadow: 0 0 20px ${props => props.primaryColor}; }
    60% { box-shadow: 0 0 20px ${props => props.primaryColor}; }
    100% { box-shadow: 0 0 -10px ${props => props.primaryColor}; }
  } animation: glowing 500ms 5;`

const ButtonElement = styled.button`
  ${prop => prop.shrink && media.phone`font-size: 11px;`};
  color: ${prop => prop.foregroundColor};
  border-color: ${prop => prop.foregroundColor} !important;
  background-color: ${prop => prop.backgroundColor};

  ${({ doGlow }) => doGlow && glowAnimation};

  &:hover {
    color: ${prop => darken(0.2, prop.foregroundColor)};
    border-color: ${prop => darken(0.2, prop.foregroundColor)} !important;
  }

  &:focus {
    box-shadow: none !important;
  }
`

function Button({
  id,
  text,
  children,
  onClick,
  inverted,
  shrinkForMobile,
  extraClassNames,
  glow,
  t,
  theme,
  disabled,
}) {
  const defaultBackgrounColor = "#ffffff"
  const foregroundColor = inverted ? defaultBackgrounColor : theme.primaryColor
  const backgroundColor = inverted ? theme.primaryColor : defaultBackgrounColor

  return (
    <ButtonElement
      id={id}
      foregroundColor={foregroundColor}
      backgroundColor={backgroundColor}
      primaryColor={theme.primaryColor}
      className={`btn ${extraClassNames}`}
      doGlow={glow}
      shrink={shrinkForMobile}
      onClick={onClick}
      role="button"
      disabled={disabled}
    >
      {children || t(text)}
    </ButtonElement>
  )
}

Button.propTypes = {
  id: PropTypes.string,
  children: PropTypes.node,
  disabled: PropTypes.bool,
  extraClassNames: PropTypes.string,
  glow: PropTypes.bool,
  inverted: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
  shrinkForMobile: PropTypes.bool,
  text: PropTypes.string,
  theme: PropTypes.shape({
    primaryColor: PropTypes.string.isRequired,
    primaryColorHover: PropTypes.string.isRequired,
    navBackgroundColor: PropTypes.string.isRequired,
  }).isRequired,
}

Button.defaultProps = {
  id: "",
  children: null,
  disabled: false,
  extraClassNames: "",
  glow: false,
  inverted: false,
  shrinkForMobile: false,
  text: null,
}
function mapStateToProps(state) {
  return {
    theme: state.userDetail.theme,
  }
}

export default compose(translate(), connect(mapStateToProps))(Button)



// WEBPACK FOOTER //
// ./src/components/themed-html-components/Button.jsx